/* src/app/views/template/components/edit-template-menu/edit-template-spotlight-menu/edit-template-spotlight-menu-header/edit-template-spotlight-menu-header.component.scss */
.spotlight-template-secondary-header {
  display: flex;
  flex-direction: row;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f2f2f2;
}
.spotlight-template-left-side-of-header {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.5rem;
}
.spotlight-template-right-side-of-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
}
.spotlight-template-button-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  gap: 1rem;
}
/*# sourceMappingURL=edit-template-spotlight-menu-header.component.css.map */
